import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { IconBoxProps } from '@/components/UI/IconBox/IconBox.types';
import { Overlay } from '@/components/UI/Overlay';
import {
  desktopHeaderMediaStyles,
  headerBtnTextStyles,
} from '@/components/Header/Header.styles';

export const DesktopHeaderCatalogueBtn = styled(Button).attrs({
  appearance: 'primary',
  hasPadding: false,
  borderRadius: 14,
  isBodyFontFamily: true,
})<{ $isOpen: boolean }>`
  height: 44.5px;
  margin-right: 10px;
  padding: 13px 18px 13px 15px;
  gap: ${({ $isOpen }) => ($isOpen ? 12 : 10)}px;
  border: 0;
  font-weight: 500;

  @media (max-width: 1310px) {
    min-width: 45px;
    height: 44px;
    padding: 14px 15px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.brand.mainOnHover};
  }

  ${headerBtnTextStyles}
`;

export const DesktopHeaderCatalogueBtnIcon = styled(IconBox).attrs<
  IconBoxProps & { $isOpen: boolean }
>(({ $isOpen }) =>
  $isOpen
    ? {
        $filename: 'close-catalogue.svg',
        $width: 13,
        $height: 13,
        $iconWidth: 13,
        $iconHeight: 13,
      }
    : {
        $filename: 'catalogue.svg',
        $width: 15,
        $height: 16,
        $iconWidth: 15,
        $iconHeight: 16,
      }
)``;

export const DesktopHeaderCatalogueOverlay = styled(Overlay)`
  transition: none;
  z-index: 9;
`;

export const DesktopHeaderCatalogueWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  left: 0;
  bottom: -650px;
  width: 100%;
  height: 650px;
  padding: 25px 0;
  background-color: ${({ theme }) => theme.palette.primary.background};
  transition: 0.3s ease-in-out;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.palette.secondary.border};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.palette.tertiary.labels};
    border-radius: 7px;
  }
`;

export const DesktopHeaderCatalogueBox = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  margin-left: 30px;

  ${desktopHeaderMediaStyles}
`;

export const DesktopHeaderCatalogueContent = styled.div`
  display: flex;
  height: 100%;
`;
